import { createSlice } from "@reduxjs/toolkit";
import { menu } from "../../../Components/Sidnavbar/menuData";
import { IMenuItem, ISideMenuPermission } from "../../../Components/Sidnavbar/ISidnavbar";

// 🔧 Helper: merges static menu with API-based permission data
const testArray = (arr: IMenuItem[], apiMenus: ISideMenuPermission[]): IMenuItem[] => {
  const seen = new Set<string>();

  const filtered = arr
    .map((item) => {
      const apiMatch = apiMenus.find((apiItem) => {
        if (item.to) {
          const normalize = (str: string) => str ? str.toLowerCase().replace(/^\/+/, "") : "";
          const itemTo = normalize(item.to);
          return (
            normalize(apiItem.screen_url) === itemTo ||
            normalize(apiItem.screen_path) === itemTo
          );
        }
        return (
          apiItem.screen_name?.toLowerCase() === item.to?.toLowerCase() ||
          apiItem.screen_name?.toLowerCase() === item.title?.toLowerCase()
        );
      });


      if (item.items && item.items.length > 0) {
        const filteredChildren = testArray(item.items, apiMenus);

        if (filteredChildren.length > 0 || apiMatch) {
          return {
            ...item,
            permissions: {
              add: apiMatch?.permissions?.add ?? false,
              view: apiMatch?.permissions?.view ?? !!apiMatch,
              edit: apiMatch?.permissions?.edit ?? false,
              delete: apiMatch?.permissions?.delete ?? false,
              show: item.permissions?.show ?? false,
            },
            items: filteredChildren,
          };
        }
        return null;
      }


      if (apiMatch) {
        const uniqueKey = item.to?.toLowerCase() ?? `${item.title?.toLowerCase()}-${Math.random()}`;
        if (seen.has(uniqueKey)) return null;
        seen.add(uniqueKey);

        return {
          ...item,
          permissions: {
            add: apiMatch?.permissions?.add ?? false,
            view: apiMatch?.permissions?.view ?? true,
            edit: apiMatch?.permissions?.edit ?? false,
            delete: apiMatch?.permissions?.delete ?? false,
            show: item.permissions?.show ?? false,
          },
        };
      }

      return null;
    })
    .filter(Boolean) as IMenuItem[];

  return filtered;
};


const loopArray = (arr: { [key: string]: IMenuItem[] }, apiMenus: any[]) => {
  const newArr: { [key: string]: IMenuItem[] } = {};
  Object.keys(arr).forEach((key) => {
    newArr[key] = testArray(arr[key], apiMenus);
  });
  return newArr;
};


export interface ISideMenu {
  data: { [key: string]: IMenuItem[] };
  isLoading?: boolean;
}


export const SideMenuPermissionSlice = createSlice({
  name: "SideMenuPermission",
  initialState: { data: {} } as ISideMenu,
  reducers: {
    listSideMenuPermission: (state) => {
      state.isLoading = true;
    },
    responseSideMenuPermission: (state, action) => {
      const gettedData = action.payload;
      if (gettedData) {
        const updatedMenu = loopArray(menu, gettedData);
        state.data = updatedMenu;
        console.log("✅ Updated Menu:", updatedMenu);
      } else {
        state.data = {};
      }
      state.isLoading = false;
    },
    clearMenu: (state) => {
      state.data = {};
    },
  },
});

export const {
  listSideMenuPermission,
  responseSideMenuPermission,
  clearMenu,
} = SideMenuPermissionSlice.actions;

export default SideMenuPermissionSlice.reducer;
